<template>
    <header id="mainheader"
            :style="styles"
            :class="{'header-no-scroll': headerNoScroll, 'header-shadow': headerShadow}">
        <router-link :to="{ name: $i18n.locale+'.home' }" class="brand" :style="'width: '+size+'px'">
            <img src="/assets/img/logo-monvin.svg" alt="Monvin">
        </router-link>
        <nav ref="menu" class="main-menu">
            <ul>
                <router-link @click.native="closeMenu()" tag="li" :to="{ name: $i18n.locale+'.home' }" exact><a>Home</a></router-link>
                <router-link @click.native="closeMenu()" tag="li" :to="{ name: $i18n.locale+'.about' }"><a v-t="'menu.about'"></a></router-link>
                <router-link v-if="! viewSteelKeg" @click.native="closeMenu()" tag="li" :to="packageRoute">
                    <a v-t="'menu.package'"></a>
                </router-link>
                <li v-if="viewSteelKeg" class="has-dropdown">
                    <router-link :to="packageRoute" :event="''" @click.native.prevent="openDropdown( 'package', packageRoute )" v-t="'menu.package'"></router-link>
                    <ul :class="{'active': hasDropdown.package}" class="dropdown-menu">
                        <router-link @click.native="closeMenu()" tag="li" :to="{ name: $i18n.locale+'.steelKeg' }"><a v-t="'menu.steelKeg'"></a></router-link>
                        <router-link @click.native="closeMenu()" tag="li" :to="{ name: $i18n.locale+'.keyKeg' }"><a  v-t="'menu.keyKeg'"></a></router-link>
                    </ul>
                </li>
                <li class="has-dropdown">
                    <router-link :to="{ name: $i18n.locale+'.collection' }" :event="''" @click.native.prevent="openDropdown( 'wines', { name: $i18n.locale+'.collection' } )" v-t="'menu.collection'"></router-link>
                    <ul v-if="viewSteelKeg" :class="{'active': hasDropdown.wines}" class="dropdown-menu">
                        <li class="has-dropdown">
                            <router-link
                                    :event="''" @click.native.prevent="openDropdown( 'white', { name: $i18n.locale+'.collection.wine', params: { wine: $t('routes.wines.white') } } )"
                                    v-t="'menu.wines.white'" tag="a" :to="{ name: $i18n.locale+'.collection.wine', params: { wine: $t('routes.wines.white') } }"></router-link>
                            <ul :class="{'active': hasDropdown.white}" class="dropdown-menu">
                                <router-link @click.native="closeMenu()" tag="li" :to="{ name: $i18n.locale+'.collection.wine', params: { wine: $t('routes.wines.white') }, query: { package: 'steel' } }"><a v-t="'menu.steelKeg'"></a></router-link>
                                <router-link @click.native="closeMenu()" tag="li" :to="{ name: $i18n.locale+'.collection.wine', params: { wine: $t('routes.wines.white') }, query: { package: 'keykeg' } }"><a v-t="'menu.keyKeg'"></a></router-link>
                            </ul>
                        </li>
                        <li class="has-dropdown">
                            <router-link
                                    :event="''" @click.native.prevent="openDropdown( 'red', { name: $i18n.locale+'.collection.wine', params: { wine: $t('routes.wines.red') } } )"
                                    :to="{ name: $i18n.locale+'.collection.wine', params: { wine: $t('routes.wines.red') } }" v-t="'menu.wines.red'"></router-link>
                            <ul :class="{'active': hasDropdown.red}" class="dropdown-menu">
                                <router-link @click.native="closeMenu()" tag="li" :to="{ name: $i18n.locale+'.collection.wine', params: { wine: $t('routes.wines.red') }, query: { package: 'steel' } }"><a v-t="'menu.steelKeg'"></a></router-link>
                                <router-link @click.native="closeMenu()" tag="li" :to="{ name: $i18n.locale+'.collection.wine', params: { wine: $t('routes.wines.red') }, query: { package: 'keykeg' } }"><a v-t="'menu.keyKeg'"></a></router-link>
                            </ul>
                        </li>
                        <li class="has-dropdown">
                            <router-link
                                    :event="''" @click.native.prevent="openDropdown( 'sparkling', { name: $i18n.locale+'.collection.wine', params: { wine: $t('routes.wines.sparkling') } } )"
                                    :to="{ name: $i18n.locale+'.collection.wine', params: { wine: $t('routes.wines.sparkling') } }" v-t="'menu.wines.sparkling'"></router-link>
                            <ul :class="{'active': hasDropdown.sparkling}" class="dropdown-menu">
                                <router-link @click.native="closeMenu()" tag="li" :to="{ name: $i18n.locale+'.collection.wine', params: { wine: $t('routes.wines.sparkling') }, query: { package: 'steel' } }"><a v-t="'menu.steelKeg'"></a></router-link>
                                <router-link @click.native="closeMenu()" tag="li" :to="{ name: $i18n.locale+'.collection.wine', params: { wine: $t('routes.wines.sparkling') }, query: { package: 'keykeg' } }"><a v-t="'menu.keyKeg'"></a></router-link>
                            </ul>
                        </li>
                    </ul>
                    <ul v-if="! viewSteelKeg" :class="{'active': hasDropdown.wines}" class="dropdown-menu">
                        <router-link @click.native="closeMenu()" tag="li" :to="{ name: $i18n.locale+'.collection.wine', params: { wine: $t('routes.wines.white') } }"><a v-t="'menu.wines.white'"></a></router-link>
                        <router-link @click.native="closeMenu()" tag="li" :to="{ name: $i18n.locale+'.collection.wine', params: { wine: $t('routes.wines.red') } }"><a v-t="'menu.wines.red'"></a></router-link>
                        <router-link @click.native="closeMenu()" tag="li" :to="{ name: $i18n.locale+'.collection.wine', params: { wine: $t('routes.wines.sparkling') } }"><a v-t="'menu.wines.sparkling'"></a></router-link>
                    </ul>
                </li>
                <router-link @click.native="closeMenu()" tag="li" :to="{ name: $i18n.locale+'.be_smart' }"><a v-t="'menu.be_smart'"></a></router-link>
                <router-link @click.native="closeMenu()" tag="li" :to="{ name: $i18n.locale+'.contact' }"><a href="#" v-t="'menu.contact'"></a></router-link>
                <language-selector></language-selector>
            </ul>
            <button @click.prevent="closeMenu()" class="close"><i class="fas fa-times"></i></button>
        </nav>
        <button class="open-menu" @click.prevent="openMenu()"><i class="fas fa-bars"></i></button>
    </header>
</template>
<script>
    import TweenLite from 'gsap'
    import LanguageSelector from './../components/LanguageSelector'
    export default {
        components: {
            LanguageSelector
        },
        data() {
            return {
                headerNoScroll: false,
                headerShadow: false,
                fadeStart: 0,
                fadeEnd: 450,
                opacity: 0,
                padding: 2,
                logo: {
                    start: 100,
                    end: 70
                },
                size: 100,
                hasDropdown: {
                    wines: false,
                    package: false,
                    white: false,
                    red: false,
                    sparkling: false
                }
            }
        },
        mounted() {
            this.headerNoScroll = ( this.$route.meta.headerNoScroll ) ? true : false
            this.headerShadow = ( this.$route.meta.headerShadow ) ? true : false
            window.addEventListener('scroll', this.scroll.bind(this))
        },
        methods: {
            scroll() {
                if( this.headerNoScroll ) return

                let el = document.scrollingElement || document.documentElement;
                let offset = el.scrollTop;
                this.padding = 2;
                this.size = this.logo.start;
                let opacity = 1;

                if( window.matchMedia('(max-width: 1100px)').matches ) {
                    opacity = .75;
                }

                if( offset <= this.fadeStart ) {
                    this.opacity = 0;
                    this.size = this.logo.start;
                }else if( offset >= this.fadeEnd ) {
                    this.padding = 1;
                    this.opacity = opacity;
                    this.size = this.logo.end;
                } else if(  offset >= this.fadeStart ) {
                    this.opacity = ( (offset / this.fadeEnd) < opacity) ? (offset / this.fadeEnd) : opacity;
                    this.padding -= (offset / this.fadeEnd);
                    this.size -= ((this.logo.start - this.logo.end) * (offset / this.fadeEnd) )
                }
            },
            openDropdown( dropdown, route ) {
                if( window.matchMedia('(max-width: 1100px)').matches ) {
                    this.hasDropdown[dropdown] = !this.hasDropdown[dropdown];
                } else {
                    this.$router.push(route)
                }
            },
            openMenu() {
                if( window.matchMedia('(max-width: 1100px)').matches ) {
                    TweenLite.set( this.$refs.menu, { display: 'block' } )
                    TweenLite.to( this.$refs.menu, .5, { right: 0 } )
                }
            },
            closeMenu() {
                let _vue = this
                if( window.matchMedia('(max-width: 1100px)').matches ) {
                    TweenLite.to( this.$refs.menu, .5, { right: '-90%', onComplete() {
                            TweenLite.set( _vue.$refs.menu, { display: 'none' } )
                    } } )
                }
            }
        },
        computed: {
            styles() {
                if( this.headerNoScroll ) return false
                return {
                    'background-color': 'rgba(0, 0, 0, '+this.opacity+')',
                    'padding-bottom': this.padding+'rem',
                    'padding-top': this.padding+'rem'
                }
            },
            viewSteelKeg() {
                return (this.$store.state.viewSteelKeg || this.$i18n.locale !== 'en');
            },
            packageRoute() {
                return {
                    name: ( this.$i18n.locale !== 'en' || this.$store.state.viewSteelKeg ) ? this.$i18n.locale+'.steelKeg' : this.$i18n.locale+'.keyKeg'
                }
            }
        },
        watch: {
            '$route'() {
                this.headerNoScroll = ( this.$route.meta.headerNoScroll ) ? true : false
                this.headerShadow = ( this.$route.meta.headerShadow ) ? true : false
            }
        }
    }
</script>